import { useSearchParams } from "react-router";

const useSignupSteps = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentStep = searchParams.get("step")
    ? Number(searchParams.get("step"))
    : 1;

  const goToNextStep = () => {
    setSearchParams({ step: `${currentStep + 1}` });
  };

  const goToStep = (step: number) => {
    setSearchParams({ step: `${step}` });
  };

  return {
    currentStep,
    goToStep,
    goToNextStep,
  };
};

export default useSignupSteps;
